var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWarning = function SvgIconWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.75a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M13.5 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.75 2.336a2.49 2.49 0 0 1 3.41.915l.001.002L22.41 17.5a2.5 2.5 0 0 1-2.156 3.75H3.746A2.5 2.5 0 0 1 1.59 17.5L9.838 3.253l.001-.002a2.5 2.5 0 0 1 .911-.915m-.044 1.414.865.501L3.321 18.5a.502.502 0 0 0 .43.75h16.496a.5.5 0 0 0 .43-.75L12.426 4.247a.49.49 0 0 0-.851 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconWarning;